"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Review = void 0;
var services_shared_1 = require("@playq/services-shared");
var ReviewRaw_1 = require("./ReviewRaw");
var services_common_sentiments_1 = require("@playq/services-common-sentiments");
var ReviewBase_1 = require("./ReviewBase");
var irt_1 = require("@playq/irt");
var ReviewBrief_1 = require("./ReviewBrief");
var ReviewSentiment_1 = require("./ReviewSentiment");
var ReviewID_1 = require("./ReviewID");
var Review = (function () {
    function Review(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.sentiment = services_common_sentiments_1.Sentiment[data.sentiment];
        this.atAsString = data.at;
        this.market = services_shared_1.Market[data.market];
        this.marketReviewId = data.marketReviewId;
        this.author = data.author;
        this.rating = data.rating;
        this.appVersion = typeof data.appVersion !== 'undefined' ? data.appVersion : undefined;
        this.text = data.text;
        this.language = typeof data.language !== 'undefined' ? data.language : undefined;
        this.raw = data.raw;
        this.id = new ReviewID_1.ReviewID(data.id);
    }
    Review.prototype.getPackageName = function () { return Review.PackageName; };
    Review.prototype.getClassName = function () { return Review.ClassName; };
    Review.prototype.getFullClassName = function () { return Review.FullClassName; };
    Object.defineProperty(Review.prototype, "sentiment", {
        get: function () {
            return this._sentiment;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field sentiment is not optional');
            }
            this._sentiment = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Review.prototype, "at", {
        get: function () {
            return this._at;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field at is not optional');
            }
            if (!(value instanceof Date)) {
                throw new Error('Field at expects type Date, got ' + value);
            }
            this._at = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Review.prototype, "atAsString", {
        get: function () {
            return irt_1.Formatter.writeZoneDateTime(this._at);
        },
        set: function (value) {
            if (typeof value !== 'string') {
                throw new Error('atAsString expects type string, got ' + value);
            }
            this._at = irt_1.Formatter.readZoneDateTime(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Review.prototype, "market", {
        get: function () {
            return this._market;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field market is not optional');
            }
            this._market = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Review.prototype, "marketReviewId", {
        get: function () {
            return this._marketReviewId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field marketReviewId is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field marketReviewId expects type string, got ' + value);
            }
            this._marketReviewId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Review.prototype, "author", {
        get: function () {
            return this._author;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field author is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field author expects type string, got ' + value);
            }
            this._author = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Review.prototype, "rating", {
        get: function () {
            return this._rating;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field rating is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field rating expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field rating is expected to be an integer, got ' + value);
            }
            if (value < -32768) {
                throw new Error('Field rating is expected to be not less than -32768, got ' + value);
            }
            if (value > 32767) {
                throw new Error('Field rating is expected to be not greater than 32767, got ' + value);
            }
            this._rating = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Review.prototype, "appVersion", {
        get: function () {
            return this._appVersion;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._appVersion = undefined;
                return;
            }
            if (typeof value !== 'string') {
                throw new Error('Field appVersion expects type string, got ' + value);
            }
            this._appVersion = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Review.prototype, "text", {
        get: function () {
            return this._text;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field text is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field text expects type string, got ' + value);
            }
            this._text = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Review.prototype, "language", {
        get: function () {
            return this._language;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._language = undefined;
                return;
            }
            if (typeof value !== 'string') {
                throw new Error('Field language expects type string, got ' + value);
            }
            this._language = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Review.prototype, "raw", {
        get: function () {
            return this._raw;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field raw is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field raw expects type string, got ' + value);
            }
            this._raw = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Review.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Review.prototype.toReviewBriefSerialized = function () {
        return {
            sentiment: services_common_sentiments_1.Sentiment[this.sentiment],
            at: this.atAsString,
            market: services_shared_1.Market[this.market],
            marketReviewId: this.marketReviewId,
            author: this.author,
            rating: this.rating,
            appVersion: typeof this.appVersion !== 'undefined' ? this.appVersion : undefined,
            text: this.text,
            language: typeof this.language !== 'undefined' ? this.language : undefined,
            id: this.id.serialize()
        };
    };
    Review.prototype.toReviewBrief = function () {
        return new ReviewBrief_1.ReviewBriefStruct(this.toReviewBriefSerialized());
    };
    Review.prototype.toReviewBaseSerialized = function () {
        return {
            at: this.atAsString,
            market: services_shared_1.Market[this.market],
            marketReviewId: this.marketReviewId,
            author: this.author,
            rating: this.rating,
            appVersion: typeof this.appVersion !== 'undefined' ? this.appVersion : undefined,
            text: this.text,
            language: typeof this.language !== 'undefined' ? this.language : undefined
        };
    };
    Review.prototype.toReviewBase = function () {
        return new ReviewBase_1.ReviewBaseStruct(this.toReviewBaseSerialized());
    };
    Review.prototype.toReviewSentimentSerialized = function () {
        return {
            sentiment: services_common_sentiments_1.Sentiment[this.sentiment]
        };
    };
    Review.prototype.toReviewSentiment = function () {
        return new ReviewSentiment_1.ReviewSentimentStruct(this.toReviewSentimentSerialized());
    };
    Review.prototype.toReviewRawSerialized = function () {
        return {
            raw: this.raw
        };
    };
    Review.prototype.toReviewRaw = function () {
        return new ReviewRaw_1.ReviewRawStruct(this.toReviewRawSerialized());
    };
    Review.prototype.loadReviewBriefSerialized = function (slice) {
        this.sentiment = services_common_sentiments_1.Sentiment[slice.sentiment];
        this.atAsString = slice.at;
        this.market = services_shared_1.Market[slice.market];
        this.marketReviewId = slice.marketReviewId;
        this.author = slice.author;
        this.rating = slice.rating;
        this.appVersion = typeof slice.appVersion !== 'undefined' ? slice.appVersion : undefined;
        this.text = slice.text;
        this.language = typeof slice.language !== 'undefined' ? slice.language : undefined;
        this.id = new ReviewID_1.ReviewID(slice.id);
    };
    Review.prototype.loadReviewBrief = function (slice) {
        this.loadReviewBriefSerialized(slice.serialize());
    };
    Review.prototype.loadReviewBaseSerialized = function (slice) {
        this.atAsString = slice.at;
        this.market = services_shared_1.Market[slice.market];
        this.marketReviewId = slice.marketReviewId;
        this.author = slice.author;
        this.rating = slice.rating;
        this.appVersion = typeof slice.appVersion !== 'undefined' ? slice.appVersion : undefined;
        this.text = slice.text;
        this.language = typeof slice.language !== 'undefined' ? slice.language : undefined;
    };
    Review.prototype.loadReviewBase = function (slice) {
        this.loadReviewBaseSerialized(slice.serialize());
    };
    Review.prototype.loadReviewSentimentSerialized = function (slice) {
        this.sentiment = services_common_sentiments_1.Sentiment[slice.sentiment];
    };
    Review.prototype.loadReviewSentiment = function (slice) {
        this.loadReviewSentimentSerialized(slice.serialize());
    };
    Review.prototype.loadReviewRawSerialized = function (slice) {
        this.raw = slice.raw;
    };
    Review.prototype.loadReviewRaw = function (slice) {
        this.loadReviewRawSerialized(slice.serialize());
    };
    Review.prototype.serialize = function () {
        return {
            sentiment: services_common_sentiments_1.Sentiment[this.sentiment],
            at: this.atAsString,
            market: services_shared_1.Market[this.market],
            marketReviewId: this.marketReviewId,
            author: this.author,
            rating: this.rating,
            appVersion: typeof this.appVersion !== 'undefined' ? this.appVersion : undefined,
            text: this.text,
            language: typeof this.language !== 'undefined' ? this.language : undefined,
            raw: this.raw,
            id: this.id.serialize()
        };
    };
    Review.PackageName = 'net.playq.services.lenses';
    Review.ClassName = 'Review';
    Review.FullClassName = 'net.playq.services.lenses.Review';
    return Review;
}());
exports.Review = Review;
ReviewBrief_1.ReviewBriefStruct.register(Review.FullClassName, Review);
ReviewBase_1.ReviewBaseStruct.register(Review.FullClassName, Review);
ReviewSentiment_1.ReviewSentimentStruct.register(Review.FullClassName, Review);
ReviewRaw_1.ReviewRawStruct.register(Review.FullClassName, Review);
var irt_2 = require("@playq/irt");
irt_2.Introspector.register(Review.FullClassName, {
    full: Review.FullClassName,
    short: Review.ClassName,
    package: Review.PackageName,
    type: irt_2.IntrospectorTypes.Data,
    ctor: function () { return new Review(); },
    fields: [
        {
            name: 'sentiment',
            accessName: 'sentiment',
            type: { intro: irt_2.IntrospectorTypes.Enum, full: 'net.playq.services.common.sentiments.Sentiment' }
        },
        {
            name: 'at',
            accessName: 'at',
            type: { intro: irt_2.IntrospectorTypes.Tsz }
        },
        {
            name: 'market',
            accessName: 'market',
            type: { intro: irt_2.IntrospectorTypes.Enum, full: 'net.playq.services.shared.Market' }
        },
        {
            name: 'marketReviewId',
            accessName: 'marketReviewId',
            type: { intro: irt_2.IntrospectorTypes.Str }
        },
        {
            name: 'author',
            accessName: 'author',
            type: { intro: irt_2.IntrospectorTypes.Str }
        },
        {
            name: 'rating',
            accessName: 'rating',
            type: { intro: irt_2.IntrospectorTypes.I16 }
        },
        {
            name: 'appVersion',
            accessName: 'appVersion',
            type: { intro: irt_2.IntrospectorTypes.Opt, value: { intro: irt_2.IntrospectorTypes.Str } }
        },
        {
            name: 'text',
            accessName: 'text',
            type: { intro: irt_2.IntrospectorTypes.Str }
        },
        {
            name: 'language',
            accessName: 'language',
            type: { intro: irt_2.IntrospectorTypes.Opt, value: { intro: irt_2.IntrospectorTypes.Str } }
        },
        {
            name: 'raw',
            accessName: 'raw',
            type: { intro: irt_2.IntrospectorTypes.Str }
        },
        {
            name: 'id',
            accessName: 'id',
            type: { intro: irt_2.IntrospectorTypes.Id, full: 'net.playq.services.lenses.ReviewID' }
        }
    ]
});
//# sourceMappingURL=Review.js.map